import { Box, Button, Flex, Image, Stack, Text } from "@chakra-ui/react";
import generateCdnUrl from "@raiden/library/libraries/utils/generateCdnUrl";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { FormattedMessage } from "react-intl";
import { CenteredContent } from "../CenteredContent";

export function CourbetBlock() {
  return (
    <Box>
      <CenteredContent>
        <Box
          background={{
            base: "rgba(50, 58, 61, 1)",
            xl: `url(${generateFrontPath({
              id: "@front.internal-assets",
              parameters: { filePath: "fond-rtl.png" },
              includeBasePath: true,
            })}) center right no-repeat`,
          }}
          backgroundSize={{ base: "auto", xl: "cover" }}
          padding={{ base: "0", md: "3rem" }}>
          <CenteredContent>
            <Stack
              maxW={{ base: "100%", xl: "41%" }}
              spacing="1.5rem"
              pb={{ base: "1.5rem", md: "0" }}>
              <Box display={{ base: "block", xl: "none" }}>
                <Image
                  objectFit="cover"
                  src={generateFrontPath({
                    id: "@front.internal-assets",
                    parameters: {
                      filePath: "fond-rtl-mobile.png",
                    },
                    includeBasePath: true,
                  })}
                  alt=""
                  loading="lazy"
                />
              </Box>

              <Text
                variant="h3"
                color="white"
                padding={{ base: "0 .625rem", xl: "0" }}>
                <FormattedMessage defaultMessage="Découvrez notre intervention dans la défense d’un assuré dans l’émission de Julien Courbet “Ça peut vous arriver”" />
              </Text>

              <Text color="white" padding={{ base: "0 .625rem", xl: "0" }}>
                <FormattedMessage defaultMessage="Notre expert a été contacté par Julien Courbet suite à un litige avec un client sinistré et sa compagnie d’assurance." />
              </Text>

              <Flex
                flexDir={{ base: "column", md: "row" }}
                gap="1rem"
                padding={{ base: "0 .625rem", xl: "0" }}>
                <Button
                  as="a"
                  target="_blank"
                  href={generateCdnUrl({
                    id: "@cdn/mp3-short",
                  })}
                  colorScheme="gray"
                  variant="outline"
                  _hover={{ color: "brandPrimary.700", bg: "white" }}
                  color="white">
                  <FormattedMessage defaultMessage="Écouter la version 8 min" />
                </Button>

                <Button
                  as="a"
                  target="_blank"
                  href={generateCdnUrl({
                    id: "@cdn/mp3-long",
                  })}
                  colorScheme="gray"
                  variant="outline"
                  _hover={{ color: "brandPrimary.700", bg: "white" }}
                  color="white">
                  <FormattedMessage defaultMessage="Écouter la version 13:30 min" />
                </Button>
              </Flex>
            </Stack>
          </CenteredContent>
        </Box>
      </CenteredContent>
    </Box>
  );
}
